import React, { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "นโยบายความเป็นส่วนตัว - Encraft";
  }, []);

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h1 className="mb-2">นโยบายความเป็นส่วนตัว</h1>
            <p className="text-muted mb-4">
              เว็บไซต์ encraft.org • อัปเดตล่าสุด: 20 พฤศจิกายน 2025
            </p>

            <div className="card border">
              <div className="card-body p-4 p-md-5">
                <p className="mb-4">
                  เราให้ความสำคัญกับสิทธิความเป็นส่วนตัวของคุณ นโยบายความเป็นส่วนตัวฉบับนี้
                  อธิบายว่าทาง encraft.org (&quot;เรา&quot;)
                  เก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลของคุณอย่างไร
                  เมื่อคุณเข้าใช้งานเว็บไซต์ บริการสมาชิก
                  การอ่าน/เขียนบทความ และการใช้ระบบ AI Chat
                </p>

                <hr />

                <section id="pp-1" className="mb-4">
                  <h2 className="h5">1. ขอบเขตของนโยบาย</h2>
                  <p>
                    นโยบายนี้ครอบคลุมการประมวลผลข้อมูลส่วนบุคคลที่เกิดจากการใช้งาน:
                  </p>
                  <ul>
                    <li>การเข้าใช้งานเว็บไซต์ encraft.org</li>
                    <li>การสมัครสมาชิกและจัดการบัญชีผู้ใช้</li>
                    <li>การเขียน แก้ไข และเผยแพร่บทความ</li>
                    <li>การกดถูกใจและบันทึก (bookmark) บทความ</li>
                    <li>การใช้ระบบ AI Chat</li>
                  </ul>
                </section>

                <section id="pp-2" className="mb-4">
                  <h2 className="h5">2. ข้อมูลส่วนบุคคลที่เราเก็บ</h2>

                  <h3 className="h6 mt-3">2.1 ข้อมูลที่คุณให้กับเราโดยตรง</h3>
                  <ul>
                    <li>อีเมลที่ใช้สมัครสมาชิกหรือเข้าสู่ระบบ</li>
                    <li>ชื่อแสดงผล (Display Name)</li>
                    <li>รูปโปรไฟล์ (หากคุณอัปโหลดหรือใช้จากบัญชีภายนอก)</li>
                    <li>
                      เนื้อหาที่คุณสร้าง เช่น บทความ ความคิดเห็น หรือข้อมูลโปรไฟล์
                    </li>
                  </ul>

                  <h3 className="h6 mt-3">2.2 ข้อมูลจากการใช้งานเว็บไซต์</h3>
                  <ul>
                    <li>IP Address, ประเภทเบราว์เซอร์, ประเภทอุปกรณ์</li>
                    <li>หน้าที่เข้าชม เวลาในการใช้งาน และการคลิกลิงก์ต่าง ๆ</li>
                    <li>ข้อมูลทางเทคนิคที่จำเป็นต่อการให้บริการและรักษาความปลอดภัย</li>
                  </ul>

                  <h3 className="h6 mt-3">2.3 ข้อมูลจากฟีเจอร์กดถูกใจและบันทึกบทความ</h3>
                  <ul>
                    <li>รายการบทความที่คุณกดถูกใจ</li>
                    <li>รายการบทความที่คุณบันทึกไว้ (Bookmarks)</li>
                  </ul>

                  <h3 className="h6 mt-3">2.4 ข้อมูลจากการใช้ AI Chat</h3>
                  <ul>
                    <li>
                      ข้อความที่คุณส่งให้ AI Chat เพื่อให้ระบบช่วยตอบคำถามหรือให้คำแนะนำ
                    </li>
                    <li>
                      ในระยะเริ่มต้นของบริการ เว็บไซต์จะ{" "}
                      <strong>ไม่จัดเก็บบันทึกข้อความสนทนา (Chat Logs)</strong>{" "}
                      ในฝั่ง encraft.org อย่างไรก็ตาม ข้อความดังกล่าว
                      จะถูกส่งไปประมวลผลโดยผู้ให้บริการ AI ภายนอก
                      ตามนโยบายความเป็นส่วนตัวของผู้ให้บริการนั้น
                    </li>
                  </ul>
                </section>

                <section id="pp-3" className="mb-4">
                  <h2 className="h5">3. วัตถุประสงค์ในการใช้ข้อมูล</h2>
                  <p>เราใช้ข้อมูลของคุณเพื่อวัตถุประสงค์ดังต่อไปนี้:</p>
                  <ul>
                    <li>
                      เพื่อให้บริการพื้นฐานของเว็บไซต์ เช่น สมัครสมาชิก เข้าสู่ระบบ
                      จัดเก็บโปรไฟล์ และจัดการเนื้อหาของคุณ
                    </li>
                    <li>
                      เพื่อให้คุณสามารถอ่าน เขียน กดถูกใจ และบันทึกบทความได้อย่างราบรื่น
                    </li>
                    <li>
                      เพื่อให้บริการ AI Chat ในการตอบคำถาม
                      ช่วยอธิบายเนื้อหา และให้คำแนะนำที่เกี่ยวข้อง
                    </li>
                    <li>
                      เพื่อวิเคราะห์และปรับปรุงประสบการณ์ใช้งาน
                      รวมถึงพัฒนา UI/UX และฟีเจอร์ต่าง ๆ ของเว็บไซต์
                    </li>
                    <li>
                      เพื่อรักษาความปลอดภัยของระบบ ป้องกันการใช้งานที่ผิดกฎหมาย
                      หรือกิจกรรมที่อาจเป็นอันตรายต่อเว็บไซต์และผู้ใช้รายอื่น
                    </li>
                  </ul>
                </section>

                <section id="pp-4" className="mb-4">
                  <h2 className="h5">
                    4. คุกกี้ (Cookies) และเทคโนโลยีติดตาม
                  </h2>
                  <p>
                    เว็บไซต์อาจใช้คุกกี้และเทคโนโลยีที่คล้ายกัน
                    เพื่อปรับปรุงประสบการณ์การใช้งานและวิเคราะห์การใช้งานเว็บไซต์
                  </p>
                  <ul>
                    <li>
                      <strong>Cookies ที่จำเป็นต่อการทำงานของระบบ</strong> เช่น
                      การจดจำสถานะการเข้าสู่ระบบ (Session/Auth Cookies)
                    </li>
                    <li>
                      <strong>Cookies เพื่อการวิเคราะห์</strong> เช่น การใช้
                      Google Analytics
                      เพื่อดูสถิติการเข้าชมและการใช้งานเว็บไซต์
                    </li>
                  </ul>
                  <p>
                    คุณสามารถลบหรือปิดการใช้งานคุกกี้ผ่านการตั้งค่าในเบราว์เซอร์ของคุณ
                    อย่างไรก็ตาม การปิดคุกกี้บางประเภท
                    อาจทำให้ฟังก์ชันบางอย่างของเว็บไซต์ทำงานได้ไม่สมบูรณ์
                  </p>
                </section>

                <section id="pp-5" className="mb-4">
                  <h2 className="h5">5. การเปิดเผยข้อมูลให้บุคคลภายนอก</h2>
                  <p>
                    เราจะไม่ขายหรือแลกเปลี่ยนข้อมูลส่วนบุคคลของคุณกับบุคคลที่สาม
                    อย่างไรก็ตาม เราอาจเปิดเผยข้อมูลให้กับ:
                  </p>
                  <ul>
                    <li>
                      <strong>ผู้ให้บริการภายนอก (Service Providers)</strong>{" "}
                      ที่จำเป็นต่อการให้บริการ เช่น
                      Google Cloud, OpenAI หรือระบบวิเคราะห์สถิติต่าง ๆ
                    </li>
                    <li>
                      <strong>หน่วยงานภาครัฐหรือหน่วยงานที่มีอำนาจตามกฎหมาย</strong>{" "}
                      ในกรณีที่ต้องปฏิบัติตามคำสั่งศาลหรือกฎหมายที่เกี่ยวข้อง
                    </li>
                  </ul>
                  <p>
                    ผู้ให้บริการภายนอกดังกล่าวจะได้รับข้อมูลเท่าที่จำเป็น
                    และอยู่ภายใต้ข้อกำหนดด้านความปลอดภัยและความลับของข้อมูล
                  </p>
                </section>

                <section id="pp-6" className="mb-4">
                  <h2 className="h5">
                    6. การเก็บรักษาและความปลอดภัยของข้อมูล
                  </h2>
                  <ul>
                    <li>
                      ข้อมูลของคุณจะถูกเก็บในระบบ Cloud ที่ได้มาตรฐาน
                    </li>
                    <li>
                      จำกัดการเข้าถึงข้อมูลเฉพาะผู้ที่จำเป็นต้องใช้ข้อมูลเพื่อปฏิบัติงาน
                    </li>
                    <li>
                      ใช้มาตรการด้านความปลอดภัย เช่น HTTPS,
                      การกำหนดสิทธิ์เข้าถึงฐานข้อมูล
                    </li>
                    <li>
                      เราจะเก็บข้อมูลเท่าที่จำเป็นตามวัตถุประสงค์ที่ระบุไว้ในนโยบายนี้
                      หรือเท่าที่กฎหมายอนุญาต
                    </li>
                  </ul>
                </section>

                <section id="pp-7" className="mb-4">
                  <h2 className="h5">7. สิทธิของเจ้าของข้อมูลส่วนบุคคล</h2>
                  <p>คุณในฐานะเจ้าของข้อมูลส่วนบุคคลมีสิทธิ เช่น:</p>
                  <ul>
                    <li>ขอเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคลของตน</li>
                    <li>ขอให้แก้ไขข้อมูลที่ไม่ถูกต้องหรือไม่ครบถ้วน</li>
                    <li>
                      ขอให้ลบหรือทำลายข้อมูลส่วนบุคคล
                      เมื่อไม่มีความจำเป็นต้องเก็บอีกต่อไป
                    </li>
                    <li>
                      เพิกถอนความยินยอมในการประมวลผลข้อมูล
                      (ในกรณีที่อาศัยความยินยอมเป็นหลัก)
                    </li>
                    <li>
                      ร้องเรียนต่อหน่วยงานที่กำกับดูแล
                      หากเห็นว่ามีการประมวลผลข้อมูลที่ไม่ชอบด้วยกฎหมาย
                    </li>
                  </ul>
                  <p>
                    หากต้องการใช้สิทธิดังกล่าว
                    คุณสามารถติดต่อเราได้ตามช่องทางที่ระบุในหัวข้อ
                    &quot;ช่องทางติดต่อ&quot; ด้านล่าง
                  </p>
                </section>

                <section id="pp-8" className="mb-4">
                  <h2 className="h5">8. AI Chat และความเป็นส่วนตัว</h2>
                  <ul>
                    <li>
                      ข้อความที่คุณส่งให้ AI Chat จะถูกใช้เพื่อประมวลผลคำตอบ
                      และให้บริการที่เกี่ยวข้องเท่านั้น
                    </li>
                    <li>
                      ในระยะเริ่มต้น
                      เราไม่ได้จัดเก็บบันทึกข้อความสนทนาในฝั่ง encraft.org
                      อย่างไรก็ตาม ข้อมูลอาจถูกประมวลผลโดยผู้ให้บริการ AI ภายนอก
                      ซึ่งมีนโยบายความเป็นส่วนตัวของตนเอง
                    </li>
                    <li>
                      คุณไม่ควรส่งข้อมูลที่อ่อนไหวมาก เช่น
                      ข้อมูลบัตรเครดิต รหัสผ่าน หรือข้อมูลส่วนบุคคลที่ละเอียดอ่อน
                      ผ่านระบบ AI Chat
                    </li>
                  </ul>
                </section>

                <section id="pp-9" className="mb-4">
                  <h2 className="h5">9. การปรับปรุงแก้ไขนโยบายความเป็นส่วนตัว</h2>
                  <ul>
                    <li>
                      เราขอสงวนสิทธิ์ในการปรับปรุงหรือแก้ไขนโยบายความเป็นส่วนตัวฉบับนี้
                      ได้ทุกเมื่อ
                    </li>
                    <li>
                      เมื่อมีการแก้ไข เราจะแจ้งผ่านหน้าเว็บไซต์
                      พร้อมระบุวันที่มีผลบังคับใช้
                    </li>
                    <li>
                      การที่คุณยังคงใช้งานเว็บไซต์หลังจากมีการแก้ไข
                      ถือว่าคุณยอมรับนโยบายฉบับที่ปรับปรุงแล้ว
                    </li>
                  </ul>
                </section>

                <section id="pp-10" className="mb-2">
                  <h2 className="h5">10. ช่องทางติดต่อ</h2>
                  <p>
                    หากคุณมีคำถาม ข้อเสนอแนะ หรือข้อสงสัยเกี่ยวกับนโยบายความเป็นส่วนตัวนี้
                    คุณสามารถติดต่อเราได้ที่:
                  </p>
                  <ul>
                    <li>Email: encraft.official@gmail.com</li>
                    <li>Facebook: Encraft</li>
                    <li>Instagram: encraft_org</li>
                    <li>เว็บไซต์: https://encraft.org</li>
                  </ul>
                </section>

                <p className="text-muted small mb-0">
                  เราแนะนำให้คุณกลับมาตรวจสอบหน้านี้เป็นระยะ
                  เพื่อรับทราบข้อมูลล่าสุดเกี่ยวกับวิธีที่เราคุ้มครองข้อมูลของคุณ
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
